import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../button/button.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { ListModule } from '../../../list/list.module';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { RadioGroupModule } from '../../../radio-group/radio-group.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { CalcPathComponent } from './calc-path.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputBoxModule,
    SelectBoxModule,
    RadioGroupModule,
    ButtonModule,
    ScrollViewModule,
    ListModule,
    BlockModalDragModule,
    LoadingPanelModule,
  ],
  declarations: [CalcPathComponent],
  exports: [CalcPathComponent],
})
export class CalcPathModule {}
